import * as React from 'react';
import * as Sebrae from '@sebrae/react-core';
import {BaSeForbiddenPage, BaSeLoadingPage} from '@base/react';
import { Role } from '../models/role';

export const AdminGuard = ({ children }) => {
  const { isAuthenticated, hasRole, isInitialized, login } = Sebrae.useAuth();
  if (!isInitialized) {
    return <BaSeLoadingPage />;
  }

  if (!isAuthenticated) {
    login();
    return <BaSeLoadingPage />;
  }

  if (isAuthenticated && !hasRole(Role.Administrador)) {
    return <BaSeForbiddenPage />;
  }
  return children;
};
